export const P6_STATUS_CODES = ['TK_NotStart', 'TK_Active', 'TK_Complete', 'TK_Aside'] as const;

export const P6_USER_SELECTABLE_STATUS_CODES = ['TK_NotStart', 'TK_Active', 'TK_Complete'] as const;

export type P6StatusCode = (typeof P6_STATUS_CODES)[number];
